<template>
  <div class="media-body flex-grow-1">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'BMediaBody',
}
</script>
